// removed by extract-text-webpack-plugin
module.exports = {"InputLabel":"Euex6MC75YSxZdvA6JFO9","TextArea":"uLzbIj9oM805CRSKCpMwv","VisitorPathText":"sLQ39L-kCRBZpJcM2TXa6","customerInfoSaveButton":"_2MMo77g-8F_6df5vE9Fxuy","StatsHeader":"h__IxF9ySZ8jaM_fnze23","StatsBody":"_1n0na728yHqji8hNE3e-9O"};


//////////////////
// WEBPACK FOOTER
// ./src/container/Customer/style.css
// module id = 939
// module chunks = 0